// @flow
import {BaseApi} from 'modules/api/base';

class BetApi extends BaseApi {

    abortControllers = {};

    constructor(slaveHost, password) {
        super();
        this.url = slaveHost || '';
        this.clusterAuth = password
            ? {
                'X-CLUSTER-AUTH': password,
            }
            : {};
    }

    async makeBet(data: Object) {

        if (data.zoneId in this.abortControllers) {
            this.abortControllers[data.zoneId].abort();
        }

        this.abortControllers[data.zoneId] = new AbortController();

        const response = await fetch(this.url + '/api/v1/console-process/make-bet', {
            method: 'PUT',
            body: this.formatBody({body: data, requestDataType: 'JSON'}),
            signal: this.abortControllers[data.zoneId].signal,
            headers: {
                'content-type': 'application/json',
                ...this.clusterAuth,
            },
        });
        const result = this.getResponseData(response);
        delete this.abortControllers[data.zoneId];

        return result;
    }
}

export {BetApi};